import { Button, Chip, Collapse, Grid, ListItem, Paper } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Tooltip from '@mui/material/Tooltip';
import Authorize from 'components/Authorize';
import { hasPermission } from 'components/Authorize/authorizeUtil';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import { permissions } from "components/Authorize/permissions/permissions";
import ConfirmationPopup from 'components/ConfirmationPopup';
import RowActions from 'components/DataTable/RowActions/RowActions';
import { EntityAuditTooltip } from 'components/EntityAudit/EntityAuditTooltip';
import ExportButton from "components/ExportButton/ExportButton";
import LoadButton from 'components/LoadButton/LoadButton';
import NotificationProvider from 'components/NotificationProvider';
import ReservationButton from 'components/ReservationButton/ReservationButton';
import AddActivity from "features/activity/AddActivity/AddActivity";
import { activityStatusById, activityStatuses, completeStatuses } from 'features/activity/activityConsts';
import { useDeleteActivityMutation, useGetActivityStatusReasonsQuery, useMoveToStatusMutation } from 'features/activity/activitySlice';
import { useGetAllAliasesQuery } from 'features/activity/activityStatusAliasSlice';
import ActivityStatusAliasView from 'features/activityStatusAlias/ActivityStatusAliasView';
import AttachmentsTooltip from 'features/attachments/AttachmentsTooltip';
import { AttachmentEntityTypes } from 'features/attachments/attachmentsConsts';
import { useGetClientsQuery } from 'features/clients/clientSlice';
import { FlagEntityTypes } from 'features/flag/flagsConsts';
import { useGetDeletedLotsQuery, useGetLotsQuery } from 'features/lots/lotSlice';
import NotesTooltip from 'features/notes/NotesTooltip';
import { NoteEntityTypes } from 'features/notes/notesConsts';
import { useGetVehicleActivityNotesQuery } from 'features/notes/notesSlice';
import { selectIsAdmin, selectIsClient, selectIsOwner } from 'features/user/userSlice';
import ApproverNameDialog from 'features/activity/components/ApproverNameDialog/ApproverNameDialog';
import { FlagAsset } from 'features/vehicles/Flags/FlagAsset';
import VehicleStatusView from 'features/vehicles/VehicleStatus/VehicleStatusView';
import { useGetStatusesForClientQuery } from 'features/vehicles/VehicleStatus/vehicleStatusSlice';
import {
    useDeleteVehicleDetailMutation,
    useGetVehicleDetailsQuery
} from 'features/vehicles/vehicleSlice';
import { IconApprove, IconDeleteBlue, IconEdit, IconForm, IconInfo, IconReject } from 'icons';
import { IconActivityDefault } from 'icons/mechanicals';
import ViewModuleOutlinedIcon from '@material-ui/icons/ViewModuleOutlined';
import { groupBy, orderBy } from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { useHistory, useParams } from 'react-router-dom';
import { AutoSizer } from 'react-virtualized';
import { VariableSizeList } from 'react-window';
import FormatService from "services/formatService";
import { arrayToObject } from 'utils/object-util';
import EditActivityLog from '../EditActivityLog/EditActivityLog';
import EditVehicleDetails from "../EditVehicleDetails";
import { vehicleDetailsPageStyle } from "../VehicleDetailsPageStyle";
import { vehicleActivityLogStyle } from './style';
import ActivityCustomForm from '../ActivityCustomForm/ActivityCustomForm';
import { useGetFormsForClientQuery } from 'features/Forms/formBuilder/formBuilderSlice';
import { formTypes } from 'features/Forms/formBuilder/formBuilderConsts';
import { vehicle_detail_extended_type } from 'features/vehicles/VehicleDetailExtended/VehicleDetailExtendedTypes';
import { useGetClientsWithConfigsQuery } from 'features/clients/clientConfigSlice';
import { clientConfigTypes, clientConfigTypeToName } from 'features/clients/clientConfigsSetup';
import VendorDetachedEmailDialog from 'features/vms/vendorDirectory/vendorDetachedTemplate/VendorDetachedEmailDialog';

const useResetCache = data => {
    const ref = React.useRef();
    React.useEffect(() => {
        // AutoSizer causes ref not being present on the component mount
        if (ref.current) {
            ref.current.resetAfterIndex(0);
        }
    }, [data]);
    return ref;
};


const VehicleActivityLog = ({ activityLogData, refetchActivityLog }) => {
    const classes = vehicleDetailsPageStyle();
    const activityLogClasses = vehicleActivityLogStyle();
    const history = useHistory();

    const isAdmin = useSelector(selectIsAdmin);
    const isOwner = useSelector(selectIsOwner);
    const isClient = useSelector(selectIsClient);

    const [vehicleDetailsToEdit, setVehicleDetailsToEdit] = useState(null);
    const [activityLogToEdit, setActivityLogToEdit] = useState(null);
    const [vehicleDetailToDelete, setVehicleDetailToDelete] = useState(null);
    const [emailDraft, setEmailDraft] = useState(null);
    const [emailActivityLogId, setEmailActivityLogId] = useState(null);
    const [activityToDelete, setActivityToDelete] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [expandedItems, setExpandedItems] = useState([]);
    const [showOpenNonAutomated, setShowOpenNonAutomated] = useState(false);

    const [customFormOpen, setCustomFormOpen] = useState(false);
    const [approverNameDialogOpen, setApproverNameDialogOpen] = useState(false);
    const [approverName, setApproverName] = useState('');
    const [activityToApprove, setActivityToApprove] = useState(null);

    let { id } = useParams();
    let { data: vehicleDetails, error, isLoading: isLoadingVehicle } = useGetVehicleDetailsQuery(id);
    let { data: lots, error: lotError, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: deletedLots, error: deletedLotsotError, isLoading: isLoadingDeletedLots, } = useGetDeletedLotsQuery();
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null, { skip: !isAdmin });
    let { data: allvehicleActivityNotes, error: notesError, isFetching: isLoadingNotes } = useGetVehicleActivityNotesQuery({ vehicleId: vehicleDetails?.id }, { skip: !vehicleDetails?.id });
    let { data: aliases, error: aliasError, isLoading: isLoadingAlias } = useGetAllAliasesQuery();
    let { data: clientVehicleStatuses, error: clientVehicleStatusesError, loading: clientVehicleStatusesLoading } = useGetStatusesForClientQuery({ clientId: vehicleDetails?.clientId })
    let { data: statusReasons, error: statusReasonsError, isLoading: isLoadingStatusReasons } = useGetActivityStatusReasonsQuery();
    let { data: forms, error: formError, isFetching: isLoadingForms } = useGetFormsForClientQuery({ formType: formTypes.Activity, clientId: vehicleDetails?.clientId }, { skip: !vehicleDetails?.clientId });
    let { data: clientsWithConfigs, error: clientsWithConfigsError, isLoading: isLoadingClientsWithConfigs, isFetching: isFetchingClientsWithConfigs } = useGetClientsWithConfigsQuery(vehicleDetails?.clientId);
    statusReasons = statusReasons || [];
    clientVehicleStatuses = clientVehicleStatuses || [];
    forms = forms || [];

    const clientConfig = clientsWithConfigs?.[0]?.config?.[clientConfigTypeToName[clientConfigTypes.Mechanicals]];
    const useCustomActivityConfig = clientConfig?.['useCustomActivity'] ?? [];
    const useCustomActivityConfigLookup = arrayToObject(useCustomActivityConfig, 'activityItemId');

    const formsLookup = arrayToObject(forms, 'activityItemId');

    let [deleteVehicleDetail] = useDeleteVehicleDetailMutation();
    let [deleteActivityLog] = useDeleteActivityMutation();
    let [updateStatus, { isLoadingUpdate }] = useMoveToStatusMutation();

    activityLogData = activityLogData || [];

    const clientVehicleStatusesLookup = arrayToObject(clientVehicleStatuses);
    const reasonLookup = arrayToObject(statusReasons);

    const getStatusName = (value) => {
        let statusObj = clientVehicleStatusesLookup?.[value];
        return statusObj?.name
    }

    const lotLookup = arrayToObject(lots);
    const deletedLotLookup = arrayToObject(deletedLots);

    activityLogData = activityLogData.map(a => ({
        ...a,
        action: a.actionId ?
            <VehicleStatusView value={a.actionId} clientId={vehicleDetails?.clientId} /> :
            a.action,
        formattedDate: FormatService.formatDateTimeNoConversion(lotLookup?.[a?.lotId]?.ianaTimeZone ? FormatService.formatDateByTimeZone(a.date, lotLookup?.[a?.lotId]?.ianaTimeZone) : a.date),
        formattedRequestedDate: a.requestedCompletionDate ? FormatService.formatDateNoConversion(lotLookup?.[a?.lotId]?.ianaTimeZone ? FormatService.formatDateByTimeZone(a.requestedCompletionDate, lotLookup?.[a?.lotId]?.ianaTimeZone) : a.requestedCompletionDate) : null
    }))

    const notActivities = activityLogData.filter(a => !a.activityLogId);
    const activities = orderBy(activityLogData.filter(a => a.activityLogId), ['activityDate'], ['desc']);

    const activityGroups = [];

    const groupedActivities = groupBy(activities, 'workOrderId');

    Object.keys(groupedActivities).map(workOrderId => {
        const lastActivity = groupedActivities[workOrderId]?.[0];
        activityGroups.push({
            ...lastActivity,
            subActivities: groupedActivities[workOrderId]?.filter(a => a.activityLogId !== lastActivity.activityLogId)
        });
    });

    let activityLog = orderBy([...notActivities, ...activityGroups], ['date'], ['desc']);

    const displayedActivityLog = showOpenNonAutomated
        ? activityLog.filter(a => a.activityLogId && !completeStatuses.includes(a.activityId) && a.activityId !== activityStatuses.Cancelled && !a.systemGenerated)
        : activityLog;

    const findLot = (lot_id) => {
        return lotLookup?.[lot_id] || {};
    }

    const findLotName = (lot_id) => {
        let lot = lotLookup?.[lot_id]
        if (lot) {
            return lot?.name
        } else {
            lot = deletedLotLookup?.[lot_id]
            return lot ? `${lot?.name} (Deleted)` : ""
        }
    }

    const mapExportData = v => {
        let exportData = {
            VIN: vehicleDetails?.descriptor,
            "Asset ID": vehicleDetails?.assetId,
            Date: v.date,
            Action: `${v.actionId ? getStatusName(v.actionId) : v.action} ${aliases?.find(a => a.activityStatusId === v.activityId && a.clientId === vehicleDetails?.clientId)?.alias ?? activityStatusById?.[v.activityId]?.name ?? ''}`,
            Lot: findLot(v.lotId)?.name,
            "Requested Date": v.requestedDate,
            "Days Completed In": v.daysCompletedIn ? v.daysCompletedIn : "",
            //"Within SLA": getWithinSla(v),
            "Asset Readiness": v.readinessStatus,
            "Work Order Id": v.workOrderId,
            "Repair Order": v.repairOrder,
        };

        if (isAdmin) {
            exportData.Cost = v.cost;
            exportData.Revenue = v.revenue;
        }

        return exportData;
    };

    const moveToStatus = async (activityLogId, newStatus, approverNameOverride) => {
        const res = await updateStatus({
            activityLogIds: [activityLogId],
            moveToStatus: newStatus,
            approverName: approverNameOverride ?? undefined,
            activityDate: new Date(moment().format("MMM DD, yyyy, hh:mm a") + " UTC").toISOString()
        });
        if (res?.error) {
            NotificationProvider.error(`An error occured while updating activity, please try again.`);
            return;
        } else {
            NotificationProvider.success('Successfully updated the activity');
            if (res?.data?.emailDraft) {
                setEmailDraft(res.data.emailDraft);
                setEmailActivityLogId(activityLogId);
            }
        }
    }

    const getApproveStatus = (activity) => activity.activityId == activityStatuses.PendingClientDecision
        ? activityStatuses.PendingApproval
        : activityStatuses.PricingApprovedByClient;

    const approveActivity = async (activity) => {
        const approveStatus = getApproveStatus(activity);
        const isL1 = activity.activityId == activityStatuses.PendingClientDecision && approveStatus == activityStatuses.PendingApproval;
        const isL2 = activity.activityId == activityStatuses.PendingClientApproval && approveStatus == activityStatuses.PricingApprovedByClient;

        if ((isL1 || isL2) && !isClient) {
            setApproverName('');
            setActivityToApprove(activity);
            setApproverNameDialogOpen(true);
            return;
        }
        await moveToStatus(activity?.activityLogId, approveStatus);
    }

    const onConfirmApproverName = async () => {
        setApproverNameDialogOpen(false);
        await moveToStatus(activityToApprove?.activityLogId, getApproveStatus(activityToApprove), approverName);
        setActivityToApprove(null);
        setApproverName('');
    }

    const onCancelApproverName = () => {
        setApproverNameDialogOpen(false);
        setActivityToApprove(null);
        setApproverName('');
    }

    const rejectActivity = async (activity) => {
        await moveToStatus(activity?.activityLogId, activityStatuses.Cancelled);
    }

    // function editActivityLog(activity) {
    //     if (activity.activityLogId) {
    //         setActivityLogToEdit(activity);
    //     }
    //     if (activity.vehicleDetailsId) {
    //         setVehicleDetailsToEdit(activity);
    //     }
    // }

    function showMechanicalWork(activity) {
        let linkWork = `/workorder/${activity.workOrderId}`;
        history.push(linkWork);
    }

    function deleteActivity(activity) {
        setOpenPopup(true);
        if (activity.vehicleDetailsId) {
            setVehicleDetailToDelete(activity);
            return;
        }

        if (activity.activityLogId) {
            setActivityToDelete(activity);
        }
    }

    const onVehicleDetailsSaved = () => {
        setVehicleDetailsToEdit(null);
        refetchActivityLog();
    };

    const onActivityLogSaved = ({ emailDraft } = {}) => {
        const activityLogId = activityLogToEdit?.activityLogId ?? activityLogToEdit?.id;
        setActivityLogToEdit(null);
        refetchActivityLog();
        if (emailDraft) {
            setEmailDraft(emailDraft);
            setEmailActivityLogId(activityLogId);
        }
    };

    const getWithinSla = activity => {
        if (activity.withinSla === null) {
            return "";
        }

        return activity.withinSla ? "Yes" : "No";
    };

    const onDeleteActivity = async () => {
        setOpenPopup(true);
        setIsDeleting(true);

        const result = vehicleDetailToDelete ? await deleteVehicleDetail(vehicleDetailToDelete.vehicleDetailsId) : await deleteActivityLog(activityToDelete.activityLogId);
        if (result.error) {
            NotificationProvider.error("Failed to delete the activity");
        } else {
            NotificationProvider.success("Successfully deleted the activity");
        }

        setIsDeleting(false);
        setOpenPopup(false);
        setVehicleDetailToDelete(null);
        setActivityToDelete(null);
    }

    let client = clients?.find(c => c.clientAccounts.find(ca => ca.id === vehicleDetails?.customerId));

    const getNotesForActivity = (activity) => {
        const type = activity?.activityLogId ? NoteEntityTypes.ACTIVITY : activity?.vehicleDetailsId ? NoteEntityTypes.VEHICLE_DETAIL : null;
        //For activities we show the notes for the whole group
        const ids = activity?.activityLogId ? [activity?.activityLogId, ...(activity?.subActivities?.map(a => a.id))] : [activity?.vehicleDetailsId];
        if (!type) return [];
        return allvehicleActivityNotes?.filter(note => note.entityType == type && ids.includes(note.entityId));
    }

    const getIsActivity = (activity) => {
        return !!activity?.activityLogId;
    }
    const getIsVechileDetail = (activity) => {
        return !!activity?.vehicleDetailsId;
    }

    const supportsNotes = (activity) => {
        return (getIsActivity(activity) && activity?.subActivities) || getIsVechileDetail(activity);
    }

    const getMileageValue = (activity) => {
        //here we are finding the mileage value from the activity extended details using the activityLogId for activity_log rows and taking the mileage value on the "activity" itself for vehicle_detail rows
        let value = activity?.extendedDetails?.find(d => d.activityLogId == activity.id && d.vehicleDetailExtendedTypeId == vehicle_detail_extended_type.Mileage)?.value;
        return activity?.mileage ? activity?.mileage : parseInt(value) || "";
    }

    let activityColumns = [
        {
            key: 'date',
            label: 'Date',
            component: (activity) => (
                <Grid container alignItems='center'>
                    <Grid xs={9} item><span style={{ whiteSpace: 'nowrap' }}>{activity.formattedDate}</span></Grid>
                    <Authorize profile={permissionProfiles.ASSETS.VEHICLE_ACTIVITY_VIEW_AUDIT}>
                        <Grid xs={1} item><EntityAuditTooltip
                            entity={{ ...activity, createdDate: activity.createdDate ?? activity.formattedDate }} /></Grid>
                    </Authorize>
                </Grid>
            ),
            size: 2
        },
        {
            key: 'action',
            label: 'Action',
            component: (activity) => {
                const activityContent = (
                    <>
                        {activity.action}
                        {' '}
                        <ActivityStatusAliasView activityIds={[activity?.activityId ?? vehicleDetailsToEdit?.activityId]} clientId={vehicleDetails?.clientId} readonly={true} />{activity.cancelledDate ? ' (cancelled)' : ''}
                        {activity.workOrderId ? ` (WO ${activity.workOrderId})` : ''}
                    </>
                );


                return (
                    <div className={activityLogClasses.actionCellContent}>
                        <div style={{ whiteSpace: 'normal', overflowWrap: 'anywhere', minWidth: 0, flex: '1 1 0' }}>
                            {!!activity?.activityLogBundleId ? (
                                <Tooltip
                                    arrow
                                    componentsProps={{
                                        tooltip: {
                                            className: activityLogClasses.bundleTooltip,
                                        },
                                        arrow: {
                                            className: activityLogClasses.bundleTooltipArrow,
                                        },
                                    }}
                                    title={
                                        <div>
                                            <div className={activityLogClasses.bundleTooltipTitle}>
                                                Part of {activity?.bundleName ?? 'a bundle'}
                                            </div>
                                            <div className={activityLogClasses.bundleTooltipId}>
                                                Bundle ID: {activity.activityLogBundleId}
                                            </div>
                                        </div>
                                    }
                                >
                                    <span className={activityLogClasses.bundleTooltipTrigger}>
                                        <span>{activityContent}</span>
                                        <span className={activityLogClasses.bundleTooltipIcon}>
                                            <ViewModuleOutlinedIcon fontSize='small' />
                                        </span>
                                    </span>
                                </Tooltip>
                            ) : (
                                <span>{activityContent}</span>
                            )}
                        </div>
                        {activity.loadId ? <LoadButton latestLoadID={activity.loadId} /> : activity.reservationId ? <ReservationButton reservationId={activity.reservationId} />
                            : activity.reasonId ? <div><Tooltip title={reasonLookup[parseInt(activity?.reasonId)]?.reasonText}><span><IconInfo /></span></Tooltip></div> : ''}
                    </div>
                );
            },
            size: 2
        },
        {
            label: 'Mileage',
            key: 'mileage',
            component: (activity) => (
                <>{getMileageValue(activity)}</>
            ),
            style: { flex: '0 0 70px', maxWidth: '70px' }
        },
        // {
        //     key: 'pendingApproval',
        //     label: '',
        //     component: (activity) => (
        //         <>{getIsActivity(activity) && <ActivityPriceError activity={activity} />}</>
        //     )
        // },
        {
            key: 'lot',
            label: 'Lot',
            component: (activity) => (
                <>{findLotName(activity.lotId)}</>
            ),
            size: 1
        },
        {
            key: 'requestedCompletionDate',
            label: 'Due Date',
            component: (activity) => (
                <>{FormatService.formatDate(activity.requestedCompletionDate) || "-"}</>
            ),
            size: 1
        },
        // {
        //     key: 'withinSla',
        //     label: 'Within SLA',
        //     component: (activity) => (
        //         <>{getWithinSla(activity)}</>
        //     ),
        //     size: 1

        // },
        {
            key: 'daysCompletedIn',
            label: 'Days Completed In',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ACTIVITY_DAYS_COMPLETED_IN_COLUMN,
            component: (activity) => (
                <>{activity.daysCompletedIn == null || activity.daysCompletedIn == undefined ? "-" : activity.daysCompletedIn}</>
            ),
            size: 1

        },
        {
            key: 'internalCost',
            label: 'Internal Cost',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ACTIVITY_LOG_INTERNAL_COST_COLUMN,
            component: (activity) => (
                <>{FormatService.formatCurrency(activity.cost)}</>
            ),
            style: { flex: '0 0 70px', maxWidth: '70px' }
        },
        {
            key: 'vendorQuotePrice',
            label: 'Quote Price',
            component: (activity) => (
                <>{FormatService.formatCurrency(activity.vendorQuotePrice)}</>
            ),
            style: { flex: '0 0 70px', maxWidth: '70px' }
        },
        {
            key: 'charge',
            label: 'Charge',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ACTIVITY_LOG_CHARGE_COLUMN,
            component: (activity) => (
                <>{FormatService.formatCurrency(activity.revenue)}</>
            ),
            size: 1
        },
        {
            key: 'attachments',
            label: '',
            component: (activity) => (
                <>{(getIsActivity(activity) && activity?.subActivities) && <AttachmentsTooltip entityType={AttachmentEntityTypes.ACTIVITY} entityId={activity?.activityLogId} />}</>
            ),
        },
        {
            key: 'mechanical',
            label: '',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_WO,
            component: (activity) => (
                <>{
                    activity.id ?
                        <IconButton size='small' className={activityLogClasses.actionButton}
                            variant="outlined"
                            onClick={() => showMechanicalWork(activity)}>
                            <IconActivityDefault />
                        </IconButton>
                        : null
                }</>
            )
        }
    ];

    activityColumns.push({
        key: 'notes',
        label: '',
        component: (activity) => (
            <>{supportsNotes(activity) && <NotesTooltip notes={getNotesForActivity(activity)}
                entityType={activity?.activityLogId ? NoteEntityTypes.ACTIVITY : activity?.vehicleDetailsId ? NoteEntityTypes.VEHICLE_DETAIL : null}
                entityId={activity?.activityLogId ?? activity?.vehicleDetailsId} />}</>
        ),
    })

    activityColumns.push({
        key: 'actions',
        label: 'Actions',
        profile: permissionProfiles.ASSETS.SHOW_ACTIONS_MENU,
        component: (activity) => (
            <>{showActions(activity) ? <RowActions actions={rowActions} showActionsInMenu={true} cellData={activity} /> : null}</>
        ),
    });

    const rowActions = (activity) => {
        const actions = [];

        if (activity.activityLogId) {
            actions.push({
                label: 'Edit',
                profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG,
                component: (
                    <Button
                        startIcon={<IconEdit />}
                        onClick={() => setActivityLogToEdit(activity)}
                        variant="text"
                        className={activityLogClasses.actionButton}
                    >
                        Edit
                    </Button>
                ),
            });
            if (formsLookup?.[activity.activityItemId] && useCustomActivityConfigLookup?.[activity.activityItemId]?.on) {
                actions.push({
                    label: 'Custom Form',
                    profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG,
                    component: (
                        <Button
                            startIcon={<IconForm width="16" />}
                            onClick={() => {
                                setCustomFormOpen(activity);
                            }}
                            variant="text"
                            className={activityLogClasses.actionButton}
                        >
                            View Form
                        </Button>
                    )
                });
            }
        }

        if (activity.vehicleDetailsId) {
            actions.push({
                label: 'Edit',
                profile: permissionProfiles.ASSETS.EDIT_VEHICLE_STATUS,
                component: (
                    <Button
                        startIcon={<IconEdit />}
                        onClick={() => setVehicleDetailsToEdit(activity)}
                        variant="text"
                        className={activityLogClasses.actionButton}
                    >
                        Edit
                    </Button>
                ),
            });
        }

        actions.push({
            label: 'Delete',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_DELETE_ACTIVITY_LOG,
            component:
                <>
                    <Tooltip
                        title={activity.systemGenerated ? 'This activity was generated by the system and should not be deleted' : ''}>
                        <div>
                            <Button
                                startIcon={<IconDeleteBlue size='small' width={15} />}
                                disabled={activity.systemGenerated}
                                onClick={() => deleteActivity(activity)}
                                variant='text'
                                className={activityLogClasses.actionButton}
                            >
                                Delete
                            </Button>
                        </div>
                    </Tooltip>
                </>,
        });

        if (activityCanBeApproved(activity)) {
            actions.push({
                label: 'Approve',
                profile: permissionProfiles.ACTIVITY.APPROVE_PENDING_CLIENT,
                component:
                    <>
                        <Button
                            startIcon={<IconApprove size={16} />}
                            onClick={() => approveActivity(activity)}
                            variant='text'
                            className={activityLogClasses.actionButton}
                            disabled={isLoadingUpdate}
                        >
                            Approve
                        </Button>
                    </>,
            },
                {
                    label: 'Reject',
                    profile: permissionProfiles.ACTIVITY.APPROVE_PENDING_CLIENT,
                    component:
                        <>
                            <Button
                                startIcon={<IconReject size={16} />}
                                onClick={() => rejectActivity(activity)}
                                variant='text'
                                className={activityLogClasses.actionButton}
                                disabled={isLoadingUpdate}
                            >
                                Reject
                            </Button>
                        </>,
                });
        }

        return actions;
    };

    const activityCanBeApproved = (activity) => {
        return (activity?.activityId == activityStatuses.PendingClientApproval || activity?.activityId == activityStatuses.PendingClientDecision) && !activity?.isSubActivity;
    }

    const showActions = (activity) => {
        const canEditActivity = !(activity.loadId || activity.reservationId);
        const canApprove = hasPermission(permissions.ACTIVITIES.APPROVE_PENDING_CLIENT.key) && activityCanBeApproved(activity);
        const canEditActivityLog = hasPermission(permissions.VEHICLE.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG.key) && activity.activityLogId;
        const canEditVehicleStatus = hasPermission(permissions.VEHICLE.EDIT_VEHICLE_STATUS.key) && activity.vehicleDetailsId;
        const canDelete = hasPermission(permissions.VEHICLE.ASSETS_DETAIL_PAGE_DELETE_ACTIVITY_LOG.key);

        return canEditActivity && (canDelete || canApprove || canEditActivityLog || canEditVehicleStatus || isOwner);
    };


    const Row = ({ index, style }) => (
        <ListItem style={style} key={index} >
            <ActivityItem activity={displayedActivityLog?.[index]}
                index={index} activityColumns={activityColumns} expandedItems={expandedItems} setExpandedItems={setExpandedItems} />
        </ListItem>
    );

    const getItemSize = (index) => {
        let height = 100;
        const activity = displayedActivityLog?.[index];
        if (expandedItems?.includes(index)) {
            height += (100 * activity?.subActivities?.length)
        }
        return height;
    }

    const ref = useResetCache(displayedActivityLog);

    return (
        <>
            <Paper style={{ position: 'relative', height: '35rem' }} className={classes.card} elevation={1} id="activityLog">
                <Grid container direction="row" alignItems="center" spacing={2} className={classes.titleRow}>
                    <Grid container alignItems="center" style={{ margin: '8rem, 0' }}>
                        <img src="/icons/icon-log.svg" className={classes.icon} alt="Activity Log" />
                        <h2 className={classes.title}>Activity Log</h2>
                        <Chip variant="outlined" label="All Activities" color={!showOpenNonAutomated ? "primary" : "default"} onClick={() => setShowOpenNonAutomated(false)} style={{ marginLeft: '0.8rem' }} />
                        <Chip variant="outlined" label="Open & Non-Automated" color={showOpenNonAutomated ? "primary" : "default"} onClick={() => setShowOpenNonAutomated(true)} style={{ marginLeft: '0.5rem' }} />
                        <div container className={classes.exportButtonWrapper}>
                            <Authorize profile={permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ADD_ACTIVITY_LOG}>
                                <AddActivity vehicleId={id} lotId={vehicleDetails?.lotId} clientId={client?.id}
                                    onClose={refetchActivityLog} vehicleTypeId={vehicleDetails?.vehicleTypeId}
                                    vehicleDetails={vehicleDetails} clientAccountId={vehicleDetails?.customerId} />
                            </Authorize>
                            <Authorize profile={permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ACTIVITY_LOG_EXPORT}>
                                <ExportButton fileLabel="ActivityLog" data={activityLog} mapExportData={mapExportData}
                                    vin={vehicleDetails?.descriptor} />
                            </Authorize>
                        </div>
                    </Grid>
                </Grid>
                <Grid container className={classes.activityLogContainer}>
                    <Grid container direction='column'>
                        <Grid container item alignItems="center" className={activityLogClasses.headerRow}>
                            {activityColumns.map(column =>
                                <Authorize profile={column.profile}>
                                    <Grid className={activityLogClasses.activityLogHeader} key={`header_${column.key}`} item
                                        xs={column.size} style={column.style}>
                                        {column.label}
                                    </Grid>
                                </Authorize>
                            )}
                        </Grid>
                        <AutoSizer >
                            {({ height, width }) => (
                                <VariableSizeList
                                    className="List"
                                    height={height + 300}
                                    itemCount={displayedActivityLog?.length}
                                    itemSize={getItemSize}
                                    width={width}
                                    ref={ref}
                                    itemKey={index => index}
                                >
                                    {Row}
                                </VariableSizeList>
                            )}
                        </AutoSizer>
                    </Grid>
                </Grid>
            </Paper>

            {
                !!vehicleDetailsToEdit &&
                <EditVehicleDetails vehicleDetails={vehicleDetailsToEdit} onCancel={() => setVehicleDetailsToEdit(null)}
                    onConfirm={onVehicleDetailsSaved} vehicleId={id} />
            }
            {
                !!activityLogToEdit &&
                <EditActivityLog
                    clientId={client?.id}
                    clientAccountId={vehicleDetails?.customerId}
                    activityLog={activityLogToEdit}
                    onCancel={() => setActivityLogToEdit(null)}
                    onConfirm={onActivityLogSaved}
                    vehicleTypeId={vehicleDetails?.vehicleTypeId}
                />
            }
            <ConfirmationPopup
                title={'Delete Activity'}
                onCancel={() => setOpenPopup(false)}
                onConfirm={() => onDeleteActivity()}
                open={openPopup}
                loading={isDeleting}
            >
                <div>{`Are you sure you want to delete this activity?`}</div>
            </ConfirmationPopup>
            <ActivityCustomForm
                vehicleDetails={vehicleDetails}
                activityLog={customFormOpen}
                onCancel={() => {
                    setCustomFormOpen(null);
                    history.push(`/assets/detail/${id}`);
                }} />
            <VendorDetachedEmailDialog
                open={!!emailDraft}
                onClose={() => setEmailDraft(null)}
                emailDraft={emailDraft}
                activityLogId={emailActivityLogId}
            />
            <ApproverNameDialog
                open={approverNameDialogOpen}
                onConfirm={onConfirmApproverName}
                onCancel={onCancelApproverName}
                value={approverName}
                onChange={setApproverName}
                clientAccountId={vehicleDetails?.customerId}
            />
        </>
    );
};

export default VehicleActivityLog;

const ActivityItem = ({ index, activity, activityColumns, expandedItems, setExpandedItems }) => {

    const classes = vehicleActivityLogStyle();

    const onExpand = () => {
        if (expandedItems?.includes(index)) {
            let filteredList = expandedItems.filter(l => l != index)
            setExpandedItems(filteredList);
        } else {
            setExpandedItems([...expandedItems, index]);
        }
    }

    const expanded = () => {
        return expandedItems?.includes(index);
    }

    const hasSubItems = !!activity?.subActivities?.length;
    return (
        <Grid container alignItems='center' item
            className={`${classes.activityItem} ${hasSubItems && expanded() && classes.expandedGroup}`}>
            <Grid container alignItems='center' className={`${hasSubItems && expanded() && classes.expandedRow}`}>
                <ActivityRow
                    activity={activity}
                    index={index}
                    activityColumns={activityColumns}
                    expandIcon={hasSubItems &&
                        <IconButton size='small' className={`${classes.expandIcon} ${expanded() && classes.expanded}`}
                            onClick={() => onExpand()}><ChevronRightIcon /></IconButton>}
                />
            </Grid>
            {!!activity?.subActivities?.length &&
                <Collapse in={expanded()} timeout="auto" unmountOnExit className={classes.collapseWrapper}>
                    <Grid container alignItems='center' direction='column' spacing={1}>
                        {activity?.subActivities?.map((subActivity, subIndex) => <ActivityRow activity={subActivity}
                            index={subIndex}
                            activityColumns={activityColumns} isSubActivity={true} />)}
                    </Grid>
                </Collapse>}
        </Grid>
    )
}

const ActivityRow = ({ index, activity, activityColumns, expandIcon, isSubActivity = false }) => {
    const classes = vehicleActivityLogStyle();

    return (
        <Grid container alignItems='center'>
            {activity.activityLogId && !isSubActivity &&
                <Grid className={classes.flag}>
                    <FlagAsset
                        iconOnly
                        selectedRows={[activity?.id]}
                        allData={[activity]}
                        entityType={FlagEntityTypes.ACTIVITY}
                    />
                </Grid>}
            {expandIcon}
            {activityColumns.map(column =>
                <Authorize profile={column.profile}>
                    <Grid alignItems='center' className={classes.activityCell} key={`${index}_${column.key}`} item xs={column.size} style={column.style}>
                        {column.component({ ...activity, isSubActivity })}
                    </Grid>
                </Authorize>
            )}
        </Grid>
    )
}
